<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { LayoutData } from './$types';
  import Loader from '$components/Transitions/Loader.svelte';
  import PageTransition from '$components/Transitions/PageTransition.svelte';

  import Analytics from '$components/Analytics.svelte';
  import CookieBanner from '$components/Cookies/Banner.svelte';

  interface Props {
    data: LayoutData;
    children?: Snippet;
  }

  let { data, children }: Props = $props();

  let transitionKey = $derived(data.url.pathname);
</script>

<Loader />

<PageTransition key={transitionKey}>
  {@render children?.()}
</PageTransition>

<Analytics />
<CookieBanner />
